import type { PageCategory } from "../types/page-category";

import { hasSegmentInPath } from "@homeinstead/shared";

/**
 * Ordered mapping of page category -> URL path segments that classify a page
 * into that category. Iteration order defines precedence when multiple
 * categories could match a single pathname.
 *
 * Adding a new category is a one-line change here plus extending the
 * `PageCategory` union in `../types/page-category.ts`.
 */
const PAGE_CATEGORY_SEGMENTS: ReadonlyArray<{
  category: PageCategory;
  segments: readonly string[];
}> = [{ category: "ppc", segments: ["ppc"] }];

/**
 * Returns the first matching `PageCategory` for `pathname` based on the
 * configured `PAGE_CATEGORY_SEGMENTS`, or `undefined` when no category matches.
 * Matching is case-sensitive and full-segment only (delegates to
 * `hasSegmentInPath`).
 */
function getPageCategoryFromPath(
  pathname: string | undefined | null,
): PageCategory | undefined {
  for (const { category, segments } of PAGE_CATEGORY_SEGMENTS) {
    if (hasSegmentInPath(pathname, segments)) {
      return category;
    }
  }
  return undefined;
}

export { getPageCategoryFromPath };
